import { createGlobalStyle } from "styled-components";

import bg from "src/assets/img/background-home.png";

export const GlobalStyle = createGlobalStyle`
.app-container {
  display: flex;
  transition: margin-left 0.5s;
  background: #F7F9FC; 
  min-height: 100vh;
}


 body{
    font-family: 'Archivo', sans-serif;
    background: #f7f9fc
  }

  .bg-blueish{
      background-color: rgb(230, 236, 245);
    }
  .text-main{
    color:white;
    background: #d53a23;
  }
  .bg-transparent{
    background-color: rgb(255,255,255,0.7)!important;
  }

  .bg-transparent h3{
    position: fixed;
    bottom:50%;
  }
  .bg-main{
    background: #d53a23;
  }
`;
